export default "__VITE_ASSET__D4ekgTIGTa3BsHRceEzjNA__"